import React from 'react';

export const DefaultAppState = {
    isInit: false,
    scopes: [],
    enabledFeatures: [],
    isSuspended: false,
    completedSurvey: false,
    isSubscribed: false,
    hasCustomerPermissions: false,
    hasOrderPermissions: false,
    hasFulfillmentOrderPermissions: false,
    isDev: false,
    isLoading: true,
    shopifyPlan: null,
    email: "",
    tierName: "",
    cohors: [],
    isPrePlanChange: true,
    showValidationNavigation: false,
    syncType: "",
    hideNavigation: false,
    shouldCompleteFeedbackSurvey: false,
    toggleNavigation: () => {},
    requestPermissions: () => {},
    requestChangePermissions: () => {},
    requestAdditionalPermissions: () => {},
    requestOrderPermissions: () => {},
    updateInitState: (isInit, requiredData) => {},
    onCompleteFeedbackSurvey: () => {}
}

export const AppContext = React.createContext(DefaultAppState);